import Select from "../../components/Select";
import SelectUncontrolled from "../../components/SelectUncontrolled";
import InputUncontrolled from "../../components/InputUncontrolled";

export default function SizesFields({ handleUpdate, dress, data, errors }) {
	return (
		<>
			<div className="two">
				<div>
					<SelectUncontrolled
						label="CouTOURe Club Polo Size"
						req={true}
						name="polo"
						value={data.polo}
						data={[{ value: "", name: "--" }].concat(
							["Extra Small", "Small", "Medium", "Large", "Extra Large"].map(
								(size) => {
									return { value: size, name: size };
								},
							),
						)}
						errors={errors}
						autocomplete="off"
					/>
				</div>

				<div>
					<Select
						label="Dress Size"
						req={true}
						name="dress"
						value={data.dress}
						data={[{ value: "", name: "--" }].concat(
							[
								"Extra Small 0-2",
								"Small 4-6",
								"Medium 8",
								"Large 10-12",
								"Extra Large 14",
								"1X 14-16",
								"2X 18-20",
								"3X 22-24",
								"Other",
							].map((size) => {
								return { value: size, name: size };
							}),
						)}
						update={handleUpdate}
						errors={errors}
						autocomplete="other"
					/>
				</div>
			</div>

			{dress === "Other" && (
				<div className="two">
					<div>
						<InputUncontrolled
							type="text"
							label="Other Dress Size"
							req={true}
							name="dressOther"
							value={""}
							errors={errors}
							autocomplete="off"
						/>
					</div>
					<div>
						<div className="empty" />
					</div>
				</div>
			)}
		</>
	);
}
